import {Component, OnDestroy, OnInit} from '@angular/core';
import {Subject} from 'rxjs';
import {select, Store} from '@ngrx/store';
import {IWorkflowCollectionState} from '../../../workflow/store/workflow.reducer';
import {ParticleService} from '@core/services/particle.service';
import {ActivatedRoute, Router} from '@angular/router';
import {getWorkflowReducerState, isWorkflowCleanedUp} from '../../../workflow/store/workflow.selector';
import {takeUntil} from 'rxjs/operators';
import {Configuration} from '@shared/models/configuration';
import {CreateWorkflowAction} from '../../../workflow/store/workflow.actions';

@Component({
    standalone: false,
    selector: 'particle-add-custom-survey-workflow',
  templateUrl: './add-custom-survey-workflow.component.html',
  styleUrls: ['./add-custom-survey-workflow.component.scss']
})
export class AddCustomSurveyWorkflowComponent implements OnInit, OnDestroy {
  workflowId: string;
  apiEndpointKey: string;
  workflowTemplate: string;
  workflowState$: any;
  cleanedUp$: any;
  unsubscribe$ = new Subject<void>();
  constructor(private store: Store<IWorkflowCollectionState>,
              private particleService: ParticleService,
              protected activatedRoute: ActivatedRoute,
              private router: Router) {
    this.workflowTemplate = 'import-field-in-survey-workflow';
    this.apiEndpointKey = 'DataSurveyApi';

  }

  ngOnInit() {
    this.activatedRoute.params.subscribe((params: any) => {
      this.workflowId = params.surveyId;
      this.workflowState$ = this.store.pipe(select(getWorkflowReducerState, this.workflowId));
      this.workflowState$.pipe(takeUntil(this.unsubscribe$)).subscribe(state => {
        if (state) {
          console.log('workflow', state);
          this.cleanWorkflow();
        }
      });

      const url = `${Configuration.getConfig(this.apiEndpointKey)}Command/CreateWorkflow`;
      const action = new CreateWorkflowAction(url, this.workflowId , 'Add Custom Survey', this.workflowTemplate);
      action.setParameters({
        'ApiEndpointName': 'DataSurveyApi'
      });
      this.store.dispatch(action);
    });
  }

  onGridCellValueChange($event: any) {

  }
  cleanWorkflow() {
    this.cleanedUp$ = this.store.pipe(select(isWorkflowCleanedUp, this.workflowId));
    this.cleanedUp$.pipe(takeUntil(this.unsubscribe$)).pipe(takeUntil(this.unsubscribe$)).subscribe(state => {
      if (state === 'Finished') {
        this.router.navigateByUrl(`data-survey/:${this.workflowId}`);
      } else if (state === 'Cancelled') {
        this.router.navigateByUrl(`data-survey`);
      }
    });
  }
  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
